var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9768 12.7675L13.5168 11.2275C13.7242 11.0227 13.9866 10.8824 14.2722 10.8239C14.5577 10.7653 14.8542 10.7909 15.1255 10.8975L17.0024 11.6469C17.2766 11.7582 17.5117 11.9481 17.678 12.1928C17.8444 12.4375 17.9347 12.726 17.9374 13.0219V16.4594C17.9358 16.6607 17.8935 16.8595 17.813 17.044C17.7325 17.2285 17.6155 17.3949 17.4691 17.533C17.3226 17.671 17.1497 17.7781 16.9608 17.8476C16.7719 17.9171 16.5709 17.9477 16.3699 17.9375C3.218 17.1194 0.564253 5.98188 0.0623784 1.71938C0.039081 1.51006 0.0603672 1.29818 0.124837 1.09768C0.189306 0.897175 0.295497 0.712596 0.436425 0.556082C0.577352 0.399569 0.749822 0.274667 0.942487 0.189595C1.13515 0.104523 1.34365 0.0612089 1.55425 0.0625014H4.87488C5.1712 0.0633785 5.46048 0.152885 5.70551 0.319509C5.95055 0.486133 6.14013 0.722254 6.24988 0.997501L6.99925 2.87438C7.10943 3.14461 7.13754 3.44132 7.08007 3.72743C7.0226 4.01355 6.8821 4.27639 6.67613 4.48313L5.13613 6.02313C5.13613 6.02313 6.023 12.025 11.9768 12.7675Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.0157bc2316268752c59eb4d9a7795e44.svg";
export { ForwardRef as ReactComponent };